import { useEffect } from 'react'

/**
 * Reveal `.reveal-*` elements on scroll. Uses a MutationObserver so elements
 * added AFTER mount (e.g. product cards fetched from /api/store/products, whose
 * DOM nodes are replaced when the brand catalog loads) are still observed and
 * revealed — otherwise late content stays stuck at its hidden initial opacity.
 */
export function useScrollReveal() {
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view')
            io.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' },
    )

    const observeAll = () => {
      document
        .querySelectorAll('.reveal-base:not(.in-view), .reveal-scale:not(.in-view), .reveal-fade:not(.in-view)')
        .forEach((el) => io.observe(el))
    }

    observeAll()

    // Re-scan when the DOM changes (async-loaded content). observe() is
    // idempotent per element, and :not(.in-view) skips already-revealed ones.
    const mo = new MutationObserver(() => observeAll())
    mo.observe(document.body, { childList: true, subtree: true })

    return () => {
      io.disconnect()
      mo.disconnect()
    }
  }, [])
}
